(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eclat-preloader"] && !window.DesignMode) return;
  try {
    
  
// setTimeout(function () {
//   $('.kleid_preloader').fadeOut(1000);
//  }, 2000);
  
  $(window).on("load", function() {
     setTimeout(function() {
            $('.kleid_preloader').hide(); // Oculta el preloader sin efecto de desvanecimiento
        }, 1200);
  });

  

  } catch(e) { console.error(e); }
})();
})();
